import { createSelector } from 'reselect';

import { getActiveComponentId, getActiveComponentFilter } from '../application';
import { buildComponentsWithStatus } from './helpers';

export const getComponentsLoaded = (state) => state.components.siteLoaded;

export const getStaticComponents = (state) => state.components.components;

export const getSiteComponent = createSelector(getStaticComponents, (components) =>
  components.find((component) => component.type === 'site')
);

export const checkHasSiteComponentModel = createSelector(
  [(_, siteId) => siteId, getComponentsLoaded, getSiteComponent],
  (siteId, siteLoaded, siteComponent) => {
    if (siteLoaded !== siteId || !siteComponent) {
      return false;
    }
    return siteComponent.models.length;
  }
);

export const getComponentTree = (state) => state.components.componentTree;

export const getComponentsUpdatedAt = (state) => state.components.componentsUpdatedAt;

export const getComponentsImportedAt = (state) => state.components.componentsImportedAt;

export const getComponentHashmap = (state) => state.components.hashmap;

export const getRemoteAssetInfo = (state) => state.components.remoteAssetInfo;

export const getCreatedComponent = (state) => state.components.createdComponent;

export const getComponentsStatus = (state) => state.components.componentsStatus;

export const getComponentsStatusUpdatedAt = (state) => state.components.componentsStatusUpdatedAt;

export const getComponents = createSelector(
  [getStaticComponents, getComponentsStatus],
  buildComponentsWithStatus
);

export const getActiveComponent = createSelector(
  [getComponentHashmap, getActiveComponentId],
  (hashmap, activeId) => hashmap[activeId]
);

export const getActiveComponentRemoteAssetInfo = createSelector(
  [getRemoteAssetInfo, getActiveComponentId],
  (remoteAssetInfo, activeId) => remoteAssetInfo[activeId]
);

export const getFilteredActiveComponentId = createSelector(
  [getActiveComponent, getActiveComponentFilter],
  (activeComp, acFilter) => {
    let ac = activeComp?.id || null;

    if (acFilter?.active && activeComp) {
      const { filterType, types, components } = acFilter;
      const typeIncluded = types?.length && types.includes(activeComp.type);
      const componentIncluded = components?.length && components.includes(activeComp.id);

      if (
        (filterType === 'include' && (typeIncluded || componentIncluded)) ||
        (filterType === 'exclude' && (!typeIncluded || !componentIncluded))
      ) {
        ac = null;
      }
    }
    return ac;
  }
);

export const getImportErrors = (state) => state.components.importErrors;

export const getPageComponents = (state) => state.components.pageComponents;
